'use strict';

import { NamedMetric } from '../model/namedMetric';
import { ProgressMetric } from '../model/progressMetric';
import { QuarterMetric, QuarterTaxMetric } from '../model/quarterMetric';
import { SimpleMetric } from '../model/simpleMetric';

export default [
    'MetricRestService',
    (MetricRestService) => {
        const countByIndustry = (filters) => MetricRestService.countByIndustry(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const countByStatus = (filters) => MetricRestService.countByStatus(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const countByPhase = (filters) => MetricRestService.countByPhase(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const countByMunicipality = (filters) => MetricRestService.countByMunicipality(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const resourceSupport = (filters) => MetricRestService.resourceSupport(filters)
            .$promise
            .then(data => data.map(metric => new ProgressMetric(metric)));

        const factFund = (filters) => MetricRestService.factFund(filters)
            .$promise
            .then(data => new SimpleMetric(data));

        const planFundsTotal = (filters) => MetricRestService.planFundsTotal(filters)
            .$promise
            .then(data => new SimpleMetric(data));

        const factFundBySrcCategory = (filters) => MetricRestService.factFundBySrcCategory(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const workPlace = (filters) => MetricRestService.workPlace(filters)
            .$promise
            .then(data => new ProgressMetric(data));

        const workPlaceByGroup = (filters) => MetricRestService.workPlaceByGroup(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const tax = (filters) => MetricRestService.tax(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)));

        const taxByQuarter = (filters) => MetricRestService.taxByQuarter(filters)
            .$promise
            .then(data => data.map(metric => new QuarterTaxMetric(metric)));

        const workPlaceByQuarter = (filters) => MetricRestService.workPlaceByQuarter(filters)
            .$promise
            .then(data => data.map(metric => ({
                ...metric,
                quarter: metric.quarter || 1
            })).map(metric => new QuarterMetric(metric)));

        const planFundByQuarter = (filters) => MetricRestService.planFundByQuarter(filters)
            .$promise
            .then(data => data.map(metric => new QuarterMetric(metric)));
        
        const factFundByQuarter = (filters) => MetricRestService.factFundByQuarter(filters)
            .$promise
            .then(data => data.map(metric => new QuarterMetric(metric)));

        const projectsByManagers = (filters) => MetricRestService.projectsByManagers(filters)
            .$promise
            .then(data => data.map(metric => new NamedMetric(metric)))
            
        const projectsByRisk = async (filters) => {
            let data = { phazes: [], zones: [] };
            try {
                const response = await MetricRestService.projectsByRisk(filters).$promise
                data = { phazes: response.phases, zones: response.zones };
            } catch(err) {
                console.log(err);
            }
            return data;
        }

        const fundByIndustry = async (filters) => {
            let data = [];
            try {
                data = await MetricRestService.fundByIndustry(filters).$promise
            } catch(err) {
                console.log(err);
            }
            return data;
        }

        const projectByOiv = async (filters) => {
            let data = [];
            try {
                data = await MetricRestService.projectByOiv(filters).$promise
            } catch(err) {
                console.log(err);
            }
            return data;
        }

        const projectByType = async (filters) => {
            let data = [];
            try {
                data = await MetricRestService.projectByType(filters).$promise
            } catch(err) {
                console.log(err);
            }
            return data;
        }

        const workPlaceByIndustry = async (filters) => {
            let data = [];
            try {
                data = await MetricRestService.workPlaceByIndustry(filters).$promise
            } catch(err) {
                console.log(err);
            }
            return data;
        }

        const fundsByMunicipality = async (filters) => {
            let data = [];
            try {
                data = await MetricRestService.fundsByMunicipality(filters).$promise
            } catch(err) {
                console.log(err);
            }
            return data;
        }

        return {
            countByIndustry,
            countByStatus,
            countByPhase,
            countByMunicipality,
            resourceSupport,
            factFund,
            planFundsTotal,
            factFundBySrcCategory,
            workPlace,
            workPlaceByGroup,
            tax,
            taxByQuarter,
            factFundByQuarter,
            planFundByQuarter,
            workPlaceByQuarter,
            projectsByManagers,
            projectsByRisk,
            fundByIndustry,
            projectByOiv,
            projectByType,
            workPlaceByIndustry,
            fundsByMunicipality,
        };
    },
];
